<navbar></navbar>

<ngx-spinner bdColor="rgba(0, 0, 0, .3)"
             size="medium"
             color="#fff"
             type="ball-scale-multiple">
  <p style="font-size: 20px; color: #fff">Carregando...</p>
</ngx-spinner>

<ng-container *ngIf="resultadoBusca">
  <div class="container">
    <div class="header">
      <div class="row">
        <h1>Estrutura Curricular</h1>
        <br>

        <div class="col-md-6">
          <p><b>Curso:</b> {{ resultadoBusca.curso?.nome }}</p>
          <p><b>Curriculo:</b> {{ resultadoBusca.curriculo }}</p>
          <p><b>Habilitação:</b> {{ resultadoBusca.habilitacao }}</p>
          <!--<p><b>Código do Curso:</b> {{ resultadoBusca.curso?.codigo }}</p>-->
        </div>

        <div class="col-md-6 col-lg-6 btn-status-container">
          <button>Status do currículo: <b>{{ resultadoBusca.status | sexoEStatus }}</b></button>
        </div>
      </div>
    </div>
  </div>

  <section class="section-pesquisa">
    <div class="container">
      <div class="row">
        <section class="col-md-8">
          <pdf-viewer [src]="pdf" class="pdf-content"
                      [render-text]="false"
                      [fit-to-page]="true"
                      [autoresize]="true"></pdf-viewer>
        </section>

        <section class="col-md-4 pdf-buttons">
          <div class="row pdf-buttons--">
            <div class="col-sm-12 btn-downloads">
              <a [href]="downloadLinkXML" class="btn btn-orange" [attr.download]="nomeArquivoXML">Baixar XML</a>
              <a [href]="downloadLinkRVCE" class="btn btn-orange" [attr.download]="nomeArquivoRVCE">Baixar RVCE</a>
            </div>
          </div>

          <div class="row">
            <!--<div class="col-sm-12">
              <a href="https://validadordiplomadigital.mec.gov.br/curriculo" target="_blank" class="btn btn-validar">Valide seu Currículo</a>
            </div>-->

            <div class="col-sm-12">
              <button class="btn btn-dados" [attr.aria-expanded]="dadosDiplomaOpen[1]" aria-controls="collapseBasic" (click)="open(1)">Dados da IES Emissora</button>
              <app-dados-curriculo id="collapseBasic" [collapse]="!dadosDiplomaOpen[1]" [isAnimated]="true" [dados]="resultadoBusca.ies" [tipo]="'dados-ies'"></app-dados-curriculo>
            </div>
            <div class="col-sm-12">
              <button class="btn btn-dados" [attr.aria-expanded]="dadosDiplomaOpen[2]" aria-controls="collapseBasic" (click)="open(2)">Dados do Curso</button>
              <app-dados-curriculo id="collapseBasic" [collapse]="!dadosDiplomaOpen[2]" [isAnimated]="true" [dados]="resultadoBusca.curso" [tipo]="'dados-curso'"></app-dados-curriculo>
            </div>
            <!--<div class="col-sm-12">
              <button class="btn btn-dados" [attr.aria-expanded]="dadosDiplomaOpen[3]" aria-controls="collapseBasic" (click)="open(3)">Dados do Registro</button>
              <app-dados-curriculo id="collapseBasic" [collapse]="!dadosDiplomaOpen[3]" [isAnimated]="true" [dados]="resultadoBusca?.Curso." [tipo]="'dados-registro'"></app-dados-curriculo>
            </div>-->
          </div>
        </section>
      </div>
    </div>
  </section>
</ng-container>

<ng-container *ngIf="erro">
  <div class="msg-erro-consulta">
    <alert [type]="'danger'" [dismissible]="true">Histórico não encontrado!</alert>
  </div>
</ng-container>
